const ACCESS_TOKEN_KEY = 'access_token';
const ACCESS_TOKEN_KEY_EXP = 'access_token_exp';
const REFRESH_TOKEN_KEY = 'refresh_token';
const REFRESH_TOKEN_KEY_EXP = 'refresh_token_exp';
const ACCESS_USER_KEY = 'access_user';

/*  securities/trading related cookies */
const TRADING_ACCESS_TOKEN = 'securities_access_token';
const TRADING_REFRESH_TOKEN = 'securities_refresh_token';
const TRADE_IS_LOGGED_IN = 'trade_is_logged_in';
const TRADING_ACCOUNT_TYPE = 'trading_account_type';
const LAST_TRADING_ACCOUNT_TYPE = 'last_trading_account_type';
const TRADING_BROKER = 'stockbit';

const PLAYER_ID = 'player-id';

export {
  ACCESS_TOKEN_KEY,
  ACCESS_TOKEN_KEY_EXP,
  REFRESH_TOKEN_KEY,
  REFRESH_TOKEN_KEY_EXP,
  ACCESS_USER_KEY,
  TRADING_ACCESS_TOKEN,
  TRADING_REFRESH_TOKEN,
  TRADE_IS_LOGGED_IN,
  TRADING_ACCOUNT_TYPE,
  LAST_TRADING_ACCOUNT_TYPE,
  TRADING_BROKER,
  PLAYER_ID,
};
